const signaturesFilterHistoricReducer = (state = [], action) => {
    switch(action.type){
        case 'SIGNATURES_FILTER_HISTORIC':
            return [...action.data];
        default:
            return state;
    }
}

export default signaturesFilterHistoricReducer;